module.exports = __webpack_public_path__ + "img/FGr_Logistik_Versorgungstrupp.379de04c.svg";